import {
    GET_DASHBOARD_DETAILS,
    GET_DASHBOARD_DETAILS_SUCCESS,
    GET_DASHBOARD_DETAILS_FAILURE,
    GET_NOTIFICATION_LIST,
    GET_NOTIFICATION_LIST_SUCCESS,
    GET_NOTIFICATION_LIST_FAILURE,
    READ_NOTIFICATION_LIST,
    READ_NOTIFICATION_LIST_FAILURE,
    READ_NOTIFICATION_LIST_SUCCESS,
    CLEAR_NOTIFICATION_LIST,
    CLEAR_NOTIFICATION_LIST_SUCCESS,
    CLEAR_NOTIFICATION_LIST_FAILURE,
    GET_INTERVIEW_DETAILS,
    GET_INTERVIEW_DETAILS_SUCCESS,
    GET_INTERVIEW_DETAILS_FAILURE,
    RESEND_EMAIL,
    RESEND_EMAIL_SUCCESS,
    RESEND_EMAIL_FAILURE,
    CHANGE_PASSWORD,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILURE,
    LOGOUT_USER,
    LOGOUT_USER_SUCCESS,
    LOGOUT_USER_FAILURE,
    GET_PLANS_AND_PRICING,
    GET_PLANS_AND_PRICING_SUCCESS,
    GET_PLANS_AND_PRICING_FAILURE,
    GET_BILLING_INFORMATION,
    GET_BILLING_INFORMATION_SUCCESS,
    GET_BILLING_INFORMATION_FAILURE,
    GET_POSITION_LIST,
    GET_POSITION_LIST_SUCCESS,
    GET_POSITION_LIST_FAILURE,
    GET_MANDATORY_SKILL,
    GET_MANDATORY_SKILL_SUCCESS,
    GET_MANDATORY_SKILL_FAILURE,
    FETCH_SKILLS_POSITION,
    FETCH_SKILLS_POSITION_SUCCESS,
    FETCH_SKILLS_POSITION_FAILURE,
    FETCH_SKILLS_JD,
    FETCH_SKILLS_JD_SUCCESS,
    FETCH_SKILLS_JD_FAILURE,
    POST_CHECKOUT,
    POST_CHECKOUT_SUCCESS,
    POST_CHECKOUT_FAILURE,
    FETCH_RESUME_SCORE,
    FETCH_RESUME_SCORE_SUCCESS,
    FETCH_RESUME_SCORE_FAILURE,
    GET_USER_INFORMATION,
    GET_USER_INFORMATION_SUCCESS,
    GET_USER_INFORMATION_FAILURE,
    UPDATE_USER_INFORMATION,
    UPDATE_USER_INFORMATION_SUCCESS,
    UPDATE_USER_INFORMATION_FAILURE,
    SUPPORT_REQUEST,
    SUPPORT_REQUEST_SUCCESS,
    SUPPORT_REQUEST_FAILURE,
    GET_SUPPORT_TICKET,
    GET_SUPPORT_TICKET_SUCCESS,
    GET_SUPPORT_TICKET_FAILURE,
    CLOSE_SUPPORT_TICKET,
    CLOSE_SUPPORT_TICKET_SUCCESS,
    CLOSE_SUPPORT_TICKET_FAILURE,
    ORDER_UPDATE,
    ORDER_UPDATE_SUCCESS,
    ORDER_UPDATE_FAILURE,
    CREATE_INTERVIEW,
    CREATE_INTERVIEW_SUCCESS,
    CREATE_INTERVIEW_FAILURE,
    REPLICATE_INTERVIEW,
    REPLICATE_INTERVIEW_SUCCESS,
    REPLICATE_INTERVIEW_FAILURE,
    VERIFY_PAYMENT,
    VERIFY_PAYMENT_SUCCESS,
    VERIFY_PAYMENT_FAILURE,
    APPLY_COUPON,
    APPLY_COUPON_SUCCESS,
    APPLY_COUPON_FAILURE,
    GET_BANNERS,
    GET_BANNERS_SUCCESS,
    GET_BANNERS_FAILURE,
} from '../action/types';
const INIT_STATE = {
    loading: false,
    planLoading: false,
    lists: null,
    positionList: null,
    mandatorySkill: null,
    notificationList: null,
    interviewList: null,
    userData: null,
    userInformation: null,
    supportTickets: null,
    planData: null,
    billingInformation: null,
    banners: null,
};
const Platform = (state = INIT_STATE, action) => {
    switch (action.type) {
        case APPLY_COUPON:
            return { ...state, loading: true };
        case APPLY_COUPON_SUCCESS:
            return { ...state, loading: false };
        case APPLY_COUPON_FAILURE:
            return { ...state, loading: false };

        case GET_DASHBOARD_DETAILS:
            return { ...state, loading: true };
        case GET_DASHBOARD_DETAILS_SUCCESS:
            return { ...state, loading: false, lists: action.payload };
        case GET_DASHBOARD_DETAILS_FAILURE:
            return { ...state, loading: false };

        case GET_PLANS_AND_PRICING:
            return { ...state, planLoading: true };
        case GET_PLANS_AND_PRICING_SUCCESS:
            return { ...state, planLoading: false, planData: action.payload };
        case GET_PLANS_AND_PRICING_FAILURE:
            return { ...state, planLoading: false };

        case GET_BILLING_INFORMATION:
            return { ...state, loading: true };
        case GET_BILLING_INFORMATION_SUCCESS:
            return { ...state, loading: false, billingInformation: action.payload };
        case GET_BILLING_INFORMATION_FAILURE:
            return { ...state, loading: false };

        case GET_NOTIFICATION_LIST:
            return { ...state, loading: false };
        case GET_NOTIFICATION_LIST_SUCCESS:
            return { ...state, loading: false, notificationList: action.payload };
        case GET_NOTIFICATION_LIST_FAILURE:
            return { ...state, loading: false };

        case READ_NOTIFICATION_LIST:
            return { ...state, loading: true };
        case READ_NOTIFICATION_LIST_SUCCESS:
            return { ...state, loading: false };
        case READ_NOTIFICATION_LIST_FAILURE:
            return { ...state, loading: false };

        case CLEAR_NOTIFICATION_LIST:
            return { ...state, loading: true };
        case CLEAR_NOTIFICATION_LIST_SUCCESS:
            return { ...state, loading: false };
        case CLEAR_NOTIFICATION_LIST_FAILURE:
            return { ...state, loading: false };

        case GET_INTERVIEW_DETAILS:
            return { ...state, loading: true };
        case GET_INTERVIEW_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                timeStamp: state.timeStamp > action.payload.timeStamp ? state.timeStamp : action.payload.timeStamp,
                interviewList: state.timeStamp > action.payload.timeStamp ? state.interviewList : action.payload,
            };
        case GET_INTERVIEW_DETAILS_FAILURE:
            return { ...state, loading: false };

        case FETCH_RESUME_SCORE:
            return { ...state, loading: true };
        case FETCH_RESUME_SCORE_SUCCESS:
            return { ...state, loading: false };
        case FETCH_RESUME_SCORE_FAILURE:
            return { ...state, loading: false };

        case RESEND_EMAIL:
            return { ...state, loading: true };
        case RESEND_EMAIL_SUCCESS:
            return { ...state, loading: false };
        case RESEND_EMAIL_FAILURE:
            return { ...state, loading: false };

        case LOGOUT_USER:
            return { ...state, loading: true };
        case LOGOUT_USER_SUCCESS:
            return { ...state, loading: false };
        case LOGOUT_USER_FAILURE:
            return { ...state, loading: false };

        case CHANGE_PASSWORD:
            return { ...state, loading: true };
        case CHANGE_PASSWORD_SUCCESS:
            return { ...state, loading: false };
        case CHANGE_PASSWORD_FAILURE:
            return { ...state, loading: false };

        case GET_USER_INFORMATION:
            return { ...state, loading: true };
        case GET_USER_INFORMATION_SUCCESS:
            return { ...state, loading: false, userInformation: action.payload };
        case GET_USER_INFORMATION_FAILURE:
            return { ...state, loading: false };

        case UPDATE_USER_INFORMATION:
            return { ...state, loading: true };
        case UPDATE_USER_INFORMATION_SUCCESS:
            return { ...state, loading: false };
        case UPDATE_USER_INFORMATION_FAILURE:
            return { ...state, loading: false };

        case GET_POSITION_LIST:
            return { ...state, loading: true };
        case GET_POSITION_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                positionList: action.payload,
            };
        case GET_POSITION_LIST_FAILURE:
            return { ...state, loading: false };

        case GET_MANDATORY_SKILL:
            return { ...state, loading: true };
        case GET_MANDATORY_SKILL_SUCCESS:
            return {
                ...state,
                loading: false,
                mandatorySkill: action.payload,
            };
        case GET_MANDATORY_SKILL_FAILURE:
            return { ...state, loading: false };

        case FETCH_SKILLS_POSITION:
            return { ...state, loading: true };
        case FETCH_SKILLS_POSITION_SUCCESS:
            return { ...state, loading: false };
        case FETCH_SKILLS_POSITION_FAILURE:
            return { ...state, loading: false };

        case FETCH_SKILLS_JD:
            return { ...state, loading: true };
        case FETCH_SKILLS_JD_SUCCESS:
            return { ...state, loading: false };
        case FETCH_SKILLS_JD_FAILURE:
            return { ...state, loading: false };

        case POST_CHECKOUT:
            return { ...state, loading: true };
        case POST_CHECKOUT_SUCCESS:
            return { ...state, loading: false };
        case POST_CHECKOUT_FAILURE:
            return { ...state, loading: false };

        case SUPPORT_REQUEST:
            return { ...state, loading: true };
        case SUPPORT_REQUEST_SUCCESS:
            return { ...state, loading: false };
        case SUPPORT_REQUEST_FAILURE:
            return { ...state, loading: false };

        case GET_SUPPORT_TICKET:
            return { ...state, loading: true };
        case GET_SUPPORT_TICKET_SUCCESS:
            return { ...state, loading: false, supportTickets: action.payload };
        case GET_SUPPORT_TICKET_FAILURE:
            return { ...state, loading: false };

        case CLOSE_SUPPORT_TICKET:
            return { ...state, loading: true };
        case CLOSE_SUPPORT_TICKET_SUCCESS:
            return { ...state, loading: false };
        case CLOSE_SUPPORT_TICKET_FAILURE:
            return { ...state, loading: false };

        case ORDER_UPDATE:
            return { ...state, loading: true };
        case ORDER_UPDATE_SUCCESS:
            return { ...state, loading: false };
        case ORDER_UPDATE_FAILURE:
            return { ...state, loading: false };

        case CREATE_INTERVIEW:
            return { ...state, loading: true };
        case CREATE_INTERVIEW_SUCCESS:
            return { ...state, loading: false };
        case CREATE_INTERVIEW_FAILURE:
            return { ...state, loading: false };

        case REPLICATE_INTERVIEW:
            return { ...state, loading: true };
        case REPLICATE_INTERVIEW_SUCCESS:
            return { ...state, loading: false };
        case REPLICATE_INTERVIEW_FAILURE:
            return { ...state, loading: false };

        case VERIFY_PAYMENT:
            return { ...state, loading: true };
        case VERIFY_PAYMENT_SUCCESS:
            return { ...state, loading: false };
        case VERIFY_PAYMENT_FAILURE:
            return { ...state, loading: false };

        case GET_BANNERS:
            return { ...state, loading: true };
        case GET_BANNERS_SUCCESS:
            return {
                ...state,
                loading: false,
                banners: action.payload,
            };
        case GET_BANNERS_FAILURE:
            return { ...state, loading: false };

        default:
            return state;
    }
};
export default Platform;
